export enum WebRuleType {
    Interactive = "interactive",
    CommentOnly = "comment-only",
}
